import { lazy } from 'react';
// Lazy exported to load prototype viewer on demand
const PrototypeEventsPlayer = lazy(() => import('./PrototypeEventsPlayer/PrototypeEventsPlayer'));
export { PrototypeEventsPlayer };
export { MediaPlayer, } from './MediaPlayer/LazyMediaPlayer';
export { MediaSyncProvider, useMediaSyncContext, } from './MediaPlayer/components/MediaSyncContext';
export { MediaStatus } from './MediaPlayer/components/MediaStatus';
export * from './utils';
export * from './types';
